{
  "harvest": {
    "name": "Ethiopia Farmers Harvest Teff",
    "nameHref": "https://commons.wikimedia.org/wiki/File:Ethiopia-farmers-harvest-teff.jpg",
    "by": "Esayas Ayele",
    "license": "CC BY-SA 4.0",
    "licenseHref": "https://creativecommons.org/licenses/by-sa/4.0/",
    "cropped": true
  },

  "thresh": {
    "name": "Farmers Threshing Rice Crops",
    "nameHref": "https://www.pexels.com/photo/farmers-threshing-rice-crops-9487554/",
    "by": "Imam Hossain",
    "byHref": "https://www.pexels.com/@imam-hossain-95404804/",
    "license": "Pexels license",
    "licenseHref": "https://www.pexels.com/license/",
    "cropped": true
  },

  "winnow": {
    "name": "A Woman with a Winnowing Basket",
    "nameHref": "https://www.pexels.com/photo/a-woman-with-a-winnowing-basket-19401189/",
    "by": "Mehmet Turgut Kirkgoz",
    "byHref": "https://www.pexels.com/@tkirkgoz/",
    "license": "Pexels license",
    "licenseHref": "https://www.pexels.com/license/",
    "cropped": true
  }
}
